<script>
	// Models
	import AdminUser from '@/Models/AdminUser.js';
	// Components
	import Helmet from '@/Components/Helmet.svelte';
	// Partials
	import UserDetails from '@/Partials/Profile/_UserDetails.svelte';
	import TwoFactor from '@/Partials/Profile/_TwoFactor.svelte';
	import ChangePassword from '@/Partials/Profile/_ChangePassword.svelte';
	// Stores
	import AuthUserStore from '@/Stores/AuthUserStore.js';

	$: user = AuthUserStore && $AuthUserStore;
</script>

<Helmet title="My Profile" />
<div>
	<div>
		<!-- Page Header -->
		<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
			<div class="flex items-center w-full">
				<h1 class="text-xl font-bold">My Profile</h1>
			</div>
		</div>
		<!-- /Page Header -->
		{#if user instanceof AdminUser}
			<!-- Main Section -->
			<div class="relative flex justify-between">
				<div class="w-full p-2 mx-2">
					<div>
						<div>
							<div class="flex md:flex-row flex-col space-y-4 md:space-y-0">
								<UserDetails data={user} />
								<TwoFactor data={user} />
								<ChangePassword data={user} />
							</div>
						</div>
					</div>
				</div>
			</div>
		{/if}
	</div>
</div>
